import { FormControlLabel, Switch } from "@mui/material";
import InfoTooltip from "src/components/general/InfoTooltip/InfoTooltip";

interface SystemSettingsTokenManagementToolbarProps {
  revokedCount: number;
  showRevoked: boolean;
  onShowRevokedChange: (checked: boolean) => void;
}

export default function SystemSettingsTokenManagementToolbar({
  revokedCount,
  showRevoked,
  onShowRevokedChange,
}: SystemSettingsTokenManagementToolbarProps) {
  return (
    <>
      <div className="flex items-center gap-1">
        <div className="text-xl font-medium">Tokens</div>
        <InfoTooltip>
          Tokens created before the tracking feature was enabled will appear here
          only after their first use.
        </InfoTooltip>
      </div>
      {revokedCount > 0 && (
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showRevoked}
              onChange={(_, checked) => onShowRevokedChange(checked)}
            />
          }
          label={
            <span className="text-sm text-text-secondary">
              Show revoked tokens ({revokedCount})
            </span>
          }
        />
      )}
    </>
  );
}
